import { render, staticRenderFns } from "./EmailNotificationsSettingsForm.vue?vue&type=template&id=84766558&scoped=true&"
import script from "./EmailNotificationsSettingsForm.vue?vue&type=script&lang=js&"
export * from "./EmailNotificationsSettingsForm.vue?vue&type=script&lang=js&"
import style0 from "./EmailNotificationsSettingsForm.vue?vue&type=style&index=0&id=84766558&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84766558",
  null
  
)

export default component.exports